import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

export const ProductListEmptyComponent = () => {
	const { $t } = useIntl();

	return (
		<S.EmptyListWrapper>
			<S.EmptyList>{$t('rewards.fanshop.noProducts')}</S.EmptyList>
		</S.EmptyListWrapper>
	);
};

namespace S {
	export const EmptyListWrapper = styled.div`
		height: 350px;
		align-self: center;
		justify-content: center;
		display: flex;
	`;

	export const EmptyList = styled.span`
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		align-self: center;
	`;
}
